import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import pt from 'date-fns/locale/pt';
import { forwardRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';

import {
    DatePickerComponent as SourceDatePickerComponent
} from 'SourceComponent/DatePicker/DatePicker.component';

import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.style.scss';
import './DatePicker.override.style';

registerLocale('es', es);
registerLocale('en', en);
registerLocale('fr', fr);
registerLocale('de', de);
registerLocale('pt', pt);

/** @namespace Elganso/Component/DatePicker/Component */
export class DatePickerComponent extends SourceDatePickerComponent {
    render() {
        const {
            selectedDate,
            onSetDate,
            showTimeSelect,
            showTimeSelectOnly,
            timeFormat,
            isClearable,
            currentDate,
            defaultFormat,
            defaultLanguage
        } = this.props;

        const date2 = new Date(new Date().setMonth(new Date().getMonth() + 3));

        const DateInput = forwardRef(this.renderCustomInput.bind(this));

        return (
            <DatePicker
              locale={ defaultLanguage }
              selected={ selectedDate }
              onChange={ onSetDate }
              showTimeSelect={ showTimeSelect }
              showTimeSelectOnly={ showTimeSelectOnly }
              timeFormat={ timeFormat }
              timeIntervals={ 15 }
              // dateFormat={ dateFormat }
              dateFormat={ defaultFormat }
              minDate={ currentDate }
              // maxDate={ maxDate }
              maxDate={ date2 }
              isClearable={ isClearable }
              customInput={ <DateInput /> }
            />
        );
    }
}

export default DatePickerComponent;
